import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { BorderRadiusSelector } from "@circle-react-shared/BuilderUI/Editor/fields/BorderRadius";
import { generateFormItemName } from "./Styles";

export const Corners = () => (
  <EditorCollapsable
    title={t("builder_ui.prop_type.styles.corners")}
    defaultOpen
  >
    <div className="space-y-4 px-6 py-5">
      <BorderRadiusSelector name={generateFormItemName("borderRadius")} />
    </div>
  </EditorCollapsable>
);
